import { z } from 'zod';
import { Department, RoleLevel } from '../enums';

export const RoleSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  slug: z.string(),
  description: z.string().nullable(),
  is_system: z.boolean(),
  is_active: z.boolean(),
  department: z.nativeEnum(Department).nullable(),
  level: z.nativeEnum(RoleLevel).nullable(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateRoleSchema = z.object({
  name: z.string().min(1, 'Name is required').max(100),
  description: z.string().max(500).nullable().optional(),
  permission_ids: z.array(z.string().uuid()).min(1, 'At least one permission is required'),
});

export const UpdateRoleSchema = z.object({
  name: z.string().min(1).max(100).optional(),
  description: z.string().max(500).nullable().optional(),
  permission_ids: z.array(z.string().uuid()).optional(),
  is_active: z.boolean().optional(),
});

export type Role = z.infer<typeof RoleSchema>;
export type CreateRole = z.infer<typeof CreateRoleSchema>;
export type UpdateRole = z.infer<typeof UpdateRoleSchema>;
